import { create } from 'zustand';

type ActiveStore = {
  pages: Set<string>;
  addPage(newPage: string): void;
  removePage(page: string): void;
  clearPages(): void;
};

export const useActiveStore = create<ActiveStore>((set) => ({
  pages: new Set<string>([]),
  addPage(newPage: string) {
    set((state) => ({ pages: state.pages.add(newPage) }));
  },
  removePage(page: string) {
    set((state) => {
      const newPages = Array.from(state.pages).filter((item) => item !== page);
      return { pages: new Set(newPages) };
    });
  },
  clearPages() {
    set(() => {
      return { pages: new Set<string>() };
    });
  },
}));
